import { render, staticRenderFns } from "./assistance-search.component.vue?vue&type=template&id=6410e0f6&"
import script from "./assistance-search.component.vue?vue&type=script&lang=ts&"
export * from "./assistance-search.component.vue?vue&type=script&lang=ts&"
import style0 from "./assistance-search.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assistance-search.component.vue"
export default component.exports